import { render, staticRenderFns } from "./T1Logotype.vue?vue&type=template&id=6dd69b7c&scoped=true&"
import script from "./T1Logotype.vue?vue&type=script&lang=js&"
export * from "./T1Logotype.vue?vue&type=script&lang=js&"
import style0 from "./T1Logotype.vue?vue&type=style&index=0&id=6dd69b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd69b7c",
  null
  
)

export default component.exports